import { useState } from "react";
import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

export const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={
      props.anchorOrigin
        ? {
            vertical: props.anchorOrigin.vertical,
            horizontal: props.anchorOrigin.horizontal,
          }
        : {
            vertical: "bottom",
            horizontal: "right",
          }
    }
    transformOrigin={
      props.transformOrigin
        ? {
            vertical: props.transformOrigin.vertical,
            horizontal: props.transformOrigin.horizontal,
          }
        : {
            vertical: "top",
            horizontal: "right",
          }
    }
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 87,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.02) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.02) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

const CustomizedMenuOption = ({
  label,
  options,
  onSelect,
  size,
  fullWidth,
  disabled,
  btnTestId,
  menuTestId,
  variant,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Button
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        variant={variant ?? "outlined"}
        disableElevation
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
        size={size || "small"}
        fullWidth={fullWidth}
        disabled={disabled}
        data-testid={btnTestId}
      >
        {label}
      </Button>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          "aria-labelledby": "demo-customized-button",
          "data-testid": menuTestId,
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {options.map((option, index) => (
          <MenuItem
            onClick={(e) => {
              onSelect(e);
              handleClose();
            }}
            disableRipple
            key={index}
          >
            {option}
          </MenuItem>
        ))}
      </StyledMenu>
    </div>
  );
};

export default CustomizedMenuOption;
